export const getEmailMeDialogStyles = () => ({
  dialogSurface: {
    padding: '0px !important',
  },
  dialogTitle: {
    width: '100%',
    background: '#FAFAFA',
    overflow: 'hidden',
    borderRadius: 5,
    '& .close-button': {
      position: 'absolute',
      right: '0',
      top: '0',
    },
  },
  titleImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    background: '#FAFAFA',
    '& img': {
      width: '50%',
      aspectRatio: 1,
    },
  },
  dialogForm: {
    padding: '0 5%',
    '& .error': {
      color: '#a80000',
    },
  },
  dialogContentTitle: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 600,
    color: '#242424',
    margin: '2% 25%',
    textAlign: 'center',
  },
  dialogContentText: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 400,
    color: '#000000',
    margin: '5% 25%',
    textAlign: 'center',
  },
  dialogConsentText: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: '#242424',
    textAlign: 'center',
  },
  sendButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2% 0',
  },
});
